import React, { useState } from 'react'
import PadContainer from '../../../components/PadContainer'
import TitleContainer from '../../../components/TitleContainer'
import { Button, Divider, Drawer, Dropdown, Form, Image, Input, Select, Tag } from 'antd'
import CustomTable from '../../../components/CustomTable'
import { BiEdit } from 'react-icons/bi'
import { PiDotsThreeOutlineBold } from 'react-icons/pi'
// import { FaPlus } from 'react-icons/fa6'
import { useGetDevices, useGetDisputes, usePostDisputes, usePutDispute } from '../../../hooks/devices/devices'
import { SlEye } from 'react-icons/sl'
// import { CiCalendarDate, CiLocationOn } from 'react-icons/ci'
// import { ImStopwatch } from 'react-icons/im'
import SearchPage from '../../../components/searchPage'
import FilterModal from '../../../components/FilterModal'
import { useGetProductColors } from '../../../hooks/productColor/productColor'

const DisputeTab = () => {
    const [isCreateOpen, setIsCreateOpen] = useState(false)
    const [search, setSearch] = useState('')
    const [status, setStatus] = useState('')
    const [openFilter, setOpenFilter] = useState(false)
    const [getId, setGetId] = useState()
    const [selectedData, setSelectedData] = useState({})
    const [isOpenEdit, setIsOpenEdit] = useState(false)
    const onOpenEdit = () => setIsOpenEdit(true)
    const [isViewOpen, setIsViewOpen] = useState(false)
    const onViewClose = () => setIsViewOpen(false)
    const onViewOpen = () => setIsViewOpen(true)
    const onCreateOpen = () => setIsCreateOpen(true)
    const onCloseEdit = () => {
      setIsOpenEdit(false)
      form.resetFields();
    }
    const width = window.innerWidth
    const isMobile = width <= 500
    const [form] = Form.useForm()
    const [payloadx, setPayload] = useState({
      answer: true,
      reason: "",
      id:"",
    })

  const onCreateClose = () => {
    form.resetFields()
    setIsCreateOpen(false)
  }

    const {
        data: getDevicesData,
        isFetching: getDevicesLoad,
    } = useGetDevices()

  const {
    data: getsData,
    refetch: getFetch,
    isFetching: getLoad,
  } = useGetDisputes(
    {SearchString: search, status},
    ["SearchString", "status"],
  )

  const handleEdit = (d) => {
    onOpenEdit()    
    setGetId(d.id)
  }

  const handleView = (d) => {
    setSelectedData(d)
    onViewOpen()
  }

  const columns = [
    {
      title: "Model Name",
      dataIndex: "device",
      key:"1",
      render: (e) => <div className='flex items-center gap-3'>
        <p className='text-sm font-medium text-dim'>{e?.model?.name}</p>
      </div>,
    },
    {
      title: "Brand Name",
      dataIndex: "device",
      key:"1",
      render: (e) => <div className='flex items-center gap-3'>
        <p className='text-sm font-medium text-dim'>{e?.model?.brand?.name}</p>
      </div>,
    },
    {
      title: "Product Name",
      dataIndex: "device",
      key:"1",
      render: (e) => <div className='flex items-center gap-3'>
        <p className='text-sm font-medium text-dim'>{e?.model?.product?.name}</p>
      </div>,
    },
    {
      title: "Price",
      key:"price",
      dataIndex: "device",
      render: (e) => 
      <p>{e?.price}</p>
    },
    {
      title: "Serial Number",
      key:"serialNumber",
      dataIndex: "device",
      render: (e) => 
      <p>{e?.serialNumber ? e?.serialNumber : 'N/A'}</p>
    },
    {
      title: "Imei Number 1",
      key:"imeiNumber1",
      dataIndex: "device",
      render: (e) => 
      <p>{e?.imeiNumber1 ? e?.imeiNumber1 : 'N/A'}</p>
    },
    {
      title: "Imei Number 2",
      key:"imeiNumber2",
      dataIndex: "device",
      render: (e) => 
      <p>{e?.imeiNumber2 ? e?.imeiNumber2 : 'N/A'}</p>
    },
    {
      title: "Receipt Image",
      key:"3",
      dataIndex: "device",
      render: (e) => 
        <Image src={e?.receiptImageUrl} alt='vRV' width={70} />
    },
    {
      title: "Action",
      dataIndex: "",
      render: (data,idx) => <Dropdown
        key={idx}
        trigger={["click"]}
        placement="bottomLeft" // onViewOpen
        menu={{items: [
          {key: "view", label: <button className='flex' onClick={()=>handleView(data)}><SlEye className='!text-base mx-2 py-auto' /> View</button>},
          {key: "edit", label: <button className='flex' onClick={()=>handleEdit(data)}><BiEdit className='!text-base mx-2 py-auto' /> Edit</button>},

        ]}}
      >
        <Button loading={getLoad} className='!bg-[#F2F6FC]' type='text' icon={<PiDotsThreeOutlineBold />} />
      </Dropdown>
    },
  ]

  const successAction = () => {
    onCloseEdit()
    form.resetFields();
    getFetch();
  };
    
  const {
    mutate: putAction,
    isLoading: putLoad,
  } = usePutDispute(successAction)

  const {
      mutate: postAction,
      isLoading: postLoad,
  } = usePostDisputes(successAction)

  const onSubmit = (d) => {  
      console.log(d)
      postAction(d)
  }

  const onSubmitEdit = () => {
    const payload = {
      id: getId,
      answer: payloadx.answer,
      reason: payloadx.reason,
    }
    putAction(payload)
  }

  const statusData = [
    {id: "Pending", name: "Pending"},
    {id: "Approved", name: "Approved"},
    {id: "Rejected", name: "Rejected"},
  ]
  return (
    <PadContainer loading={getLoad || getDevicesLoad}>
      <TitleContainer
        path={false}
        title="Disputes Devices Management"
        className="border border-lit rounded-xl"
        action={
          // <Button onClick={onCreateOpen} className='!bg-light_blue hidden' type='primary' size='large' icon={<FaPlus />}>Add Dispute</Button>
          
          <div className='flex'>
            <SearchPage setSearch={setSearch} size='' />
            <Button size='large' onClick={() => setOpenFilter(true)} className='!bg-light_blue mx-2' type='primary'>Filter</Button>
          </div>
        }
      >
        <CustomTable
          pagination={10}
          column={columns}
          data={getsData?.data?.data}
        //   rowSelection={handleTableSelect(rows, setRows, "_id")}
        />
      </TitleContainer>

      <FilterModal
        setOpenFilter={setOpenFilter}
        openFilter={openFilter}
        getProductsData={statusData}
        setStatus={setStatus}
      />

      <Drawer
        open={isCreateOpen}
        onClose={onCreateClose}
        width={isMobile ? width : 430}
        title={<p className='text-xl font-bold text-light_blue'>New Device</p>}
      >
        <Form
          form={form}
          layout="vertical"
          onFinish={onSubmit}
          className='relative'
        >
          <Form.Item label="Devices" name="deviceId" required>
            <Select size='large' placeholder='Select Model'>              
              {getDevicesData?.data?.data.map((e)=>(
                <Select.Option value={e.id}>{e.name}</Select.Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item label="Message" name="message">
            <Input.TextArea placeholder='Enter Message' size='large' rows={4} />
          </Form.Item>
          <div className='grid grid-cols-2 gap-5'>
            <Button onClick={onCreateClose} className='!text-light_blue !border-light_blue' size='large'>Cancel</Button>
            <Button htmlType='submit' loading={postLoad} className='!bg-light_blue hover:!bg-hover' size='large' type='primary'>Save</Button>
          </div>
        </Form>
      </Drawer>
            
      <Drawer
        open={isOpenEdit}
        onClose={onCloseEdit}
        width={isMobile ? width : 430}
        title={<p className='text-xl font-bold text-light_blue'>Update Status</p>}
      >
        <Form
          form={form}
          layout="vertical"
          onFinish={onSubmitEdit}
          className='relative'
        >
          <Form.Item label="Status">
            <Select
                size='large' 
                placeholder='Select Status' 
                value={payloadx.answer}
                onChange={(value)=> setPayload({...payloadx, answer: value})}
            >
              <Select.Option value={true}>Resolved</Select.Option>
              <Select.Option value={false}>Pending</Select.Option>
            </Select>
          </Form.Item>
          <Form.Item label="Reason">
            <Input 
              size='large' 
              placeholder='Approval Reason' 
              value={payloadx?.reason}
              onChange={({target:{value}})=> setPayload({...payloadx, reason: value})} 
            />
          </Form.Item>
          <div className='grid grid-cols-2 gap-5'>
            <Button onClick={onCreateClose} className='!text-light_blue !border-light_blue' size='large'>Cancel</Button>
            <Button htmlType='submit' loading={putLoad} className='!bg-light_blue hover:!bg-hover' size='large' type='primary'>Save</Button>
          </div>
        </Form>
      </Drawer>

      
      <Drawer
        open={isViewOpen}
        onClose={onViewClose}
        width={isMobile ? width : 430}
        title={<p className='text-xl font-bold text-light_blue'>Dispute Details</p>}
      >
        <div className='w-full'>
          <h4 className='text-xl font-bold'>Claimant</h4>
          <div className='px-5 items-center'>
            <Image width={100} alt={selectedData?.user?.firstName || 'Vendor image'} src={selectedData?.user?.profileImageUrl} />
            <div className='space-y-3 md:col-span-2'>
              <p className='text-lg font-semibold'>User Names: <span className='font-bold px-3 py-0.5'>{selectedData?.user?.firstName} {selectedData?.user?.lastName}</span> </p>
              <Divider />
              <p className='text-lg font-semibold'>
                Email: 
                <span className='font-bold px-3 py-0.5'>{selectedData?.user?.email}</span>
              </p>
              <Divider />
              <p className='text-lg font-semibold'>
                Phone: 
                <span className='font-bold px-3 py-0.5'>{selectedData?.user?.phoneNumber}</span>
              </p>
            </div>
          </div>
          <Divider />
          <h4 className='text-xl font-bold'>Current Owner</h4>
          <div className='px-5 items-center'>
            <Image width={100} alt={selectedData?.device?.user?.firstName || 'Vendor image'} src={selectedData?.user?.profileImageUrl} />
            <div className='space-y-3 md:col-span-2'>
              <p className='text-lg font-semibold'>User Names: <span className='font-bold px-3 py-0.5'>{selectedData?.device?.user?.firstName} {selectedData?.device?.user?.lastName}</span> </p>
              <Divider />
              <p className='text-lg font-semibold'>
                Email: 
                <span className='font-bold px-3 py-0.5'>{selectedData?.device?.user?.email}</span>
              </p>
              <Divider />
              <p className='text-lg font-semibold'>
                Phone: 
                <span className='font-bold px-3 py-0.5'>{selectedData?.device?.user?.phoneNumber}</span>
              </p>
            </div>
          </div>
          <Divider />
          <h4 className='text-xl font-bold'>Device Details</h4>
          <div className='w-full px-5 items-center'>
            <p className='font-semibold mt-5'>Model Name: 
            <span className='text-lg px-3 font-bold'>{selectedData?.device?.model?.name}</span>
            </p>
            <p className='font-semibold mt-5'>Brand Name: 
              <span className='text-lg px-3 font-bold'>{selectedData?.device?.model?.brand?.name}</span>
            </p>
            <p className='font-semibold mt-5'>Brand Image: 
              <span className='text-lg px-3 font-bold'>
                <Image width={50} alt={selectedData?.device?.model?.brand?.name || 'Vendor image'} src={selectedData?.device?.model?.brand?.imageUrl} />
              </span>
            </p>
            <p className='font-semibold mt-5 py-4'>Product Name: 
              <span className='text-lg px-3 font-bold'>{selectedData?.device?.model?.product?.name || "N/A"}</span>
            </p>
            <p className='font-semibold mt-5 py-4'>Product Image: <br />
              <Image className='mx-auto' width={200} alt={selectedData?.device?.model?.product?.name || 'Vendor image'} src={selectedData?.device?.model?.product?.imageUrl} />
            </p>
            <p className='font-semibold mt-5 py-4'>Product Color: 
              <span className={`text-xl px-3 font-bold`}>{selectedData?.device?.productStatus?.color || "N/A"}</span>
            </p>
            <p className='font-semibold mt-5 py-4'>Product Issue: 
              <span className='text-xl px-3 font-bold'>{selectedData?.device?.productStatus?.name || "N/A"}</span>
            </p>
            <Divider />
            <p className='font-semibold mt-5 py-4'>Serial Number:
              <span className='text-lg px-3 font-bold'>{selectedData?.device?.serialNumber || 'N/A'}</span>
            </p>
            <p className='font-semibold mt-5 py-4'>imei Number 1: 
              <span className={`text-xl px-3 font-bold`}>{selectedData?.device?.imeiNumber1 || "N/A"}</span>
            </p>
            <p className='font-semibold mt-5 py-4'>imei Number 2:
              <span className='text-xl px-3 font-bold'>{selectedData?.device?.imeiNumber2 || "N/A"}</span>
            </p>
            <p className='font-semibold mt-5 py-4'>Device Receipt: <br />
              <Image className='mx-auto' width={200} alt={selectedData?.device?.serialNumber || 'Vendor image'} src={selectedData?.device?.receiptImageUrl} />
            </p>
            <Divider />
          </div>
          <Divider />
          <p className='text-base font-semibold'>Support Note:</p>
          <p className='text-lg text-dim font-normal'>{selectedData?.message || "N/A"}</p>
          <Divider />
        </div>
      </Drawer>
    </PadContainer>
  )
}

export default DisputeTab